<template>
	<header id="sticky-header">
			<div class="header-area">
				<div class="container sm-100">
					<div class="row">
						<div class="col-md-3 col-sm-2">
							<div class="logo text-upper">
								<button id="custom-toggle" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#mobile-navbar-collapse" aria-expanded="false">
									<span class="sr-only">Toggle navigation</span>
									<span class="icon-bar"></span>
									<span class="icon-bar"></span>
									<span class="icon-bar"></span>
								</button>
								<img src="/images/logo.png" alt="logo">
							</div>
						</div>
						<div class="col-md-9 col-sm-10">
							<div class="menu-area hidden-xs">
								<DesktopNav :navigation="navigation"/>				
							</div>
							<div class="basic-mobile-menu visible-xs">
								<MobileNav :navigation="navigation" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
</template>

<script>
import MobileNav from '@/components/nav/MobileNav.vue';
import DesktopNav from '@/components/nav/DesktopNav.vue';

export default {
	name: "Header",
	props: ["navigation"],
	components: {
		MobileNav,
		DesktopNav
	}
}
</script>

<style>
#custom-toggle {
  border: 1px solid black; 
  border-radius: 2px;
	float: right;
	margin-left: 0px;
	margin-top: -6px;
	margin-bottom: 0px;
	margin-right: 0px;
}
</style>